import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrabodhamPrasangam from "./pages/PrabodhamPrasangam";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import HariParamrut from "./pages/HariParamrut";
import HariParamrutTwo from "./pages/HariParamrutTwo";
import HariParamrutThree from "./pages/HariParamrutThree";
import HariParamrutFour from "./pages/HariParamrutFour";
import HariPrasangam from "./pages/HariPrasangam";
import AksharVani from "./pages/AksharVani";
import AksharVaniTwo from "./pages/AksharVaniTwo";
import MaraSwamiji from "./pages/MaraSwamiji";
import SantVani from "./pages/SantVani";
import SantVaniTwo from "./pages/SantVaniTwo";
import SevakPravachan from "./pages/SevakPravachan";
import HaribhaktPravachan from "./pages/HaribhaktPravachan";
import MaraGuruhari from "./pages/MaraGuruhari";
import BahenoPravachan from "./pages/BahenoPravachan";
import Shorts from "./pages/Shorts";
import ShortsTwo from "./pages/ShortsTwo";
import Guest from "./pages/Guest";
import Transformation from "./pages/Transformation";
import USAYatra from "./pages/USAYatra";
import CanadaYatra from "./pages/CanadaYatra";
import EuropeYatra from "./pages/EuropeYatra";
import Vakta from "./pages/Vakta";
import SahajDarshan from "./pages/SahajDarshan";
import HighLight from "./pages/HighLight";
import SocialActivity from "./pages/SocialActivity";
import PoojaDarshan from "./pages/PoojaDarshan";
import SamvadAndNrutya from "./pages/SamvadAndNrutya";
import DeshBhakti from "./pages/DeshBhakti";
import PragatyaParv from "./pages/PragatyaParv";
import SevaBhakti from "./pages/SevaBhakti";
import Wallpaper from "./pages/Wallpaper";
import DesktopWallpaper from "./pages/DesktopWallpaper";
import Smruti from "./pages/Smruti";
import SmrutiMap from "./pages/SmrutiMap";
import Spotify from "./pages/Spotify";
import HariprabodhamSpotify from "./pages/HariprabodhamSpotify";
import IAksharSpotify from "./pages/IAksharSpotify";
import TorontoRhythmSpotify from "./pages/TorontoRhythmSpotify";
import AmbrishUpnishadSpotify from "./pages/AmbrishUpnishadSpotify";
import NiramayStudios from "./pages/NiramayStudios";
import Twitter from "./pages/Twitter";
import Shikshapatri from "./pages/Shikshapatri";
import ShikshapatriMukhpath from "./pages/ShikshapatriMukhpath";
import Calendar2026 from "./pages/Calendar2026";
import PradeshMap from "./pages/PradeshMap";
import AsojMap from "./pages/AsojMap";
import HariPrabodhamDham from "./pages/HariPrabodhamDham";
import VicharanDarshan from "./pages/VicharanDarshan";
import JivanDarshan from "./pages/JivanDarshan";
import VicharanMap from "./pages/VicharanMap";
import AnirdeshiAmrut from "./pages/AnirdeshiAmrut";
import Prite from "./pages/Prite";
import Sahradayi from "./pages/sahradayi";
import Amrutbindu from "./pages/amrutbindu";
import ChaitanyaDhodh from "./pages/chaitanyadhodh";
import AmbrishUpnishad from "./pages/AmbrishUpnishad";
import BhedeSakshiAnant from "./pages/BhedeSakshiAnant";
import HariPrasangDarshan from "./pages/HariPrasangDarshan";
import Vachanamrut from "./pages/Vachanamrut";
import SwaminiVato from "./pages/SwaminiVato";
import SwaminiVatoTwo from "./pages/SwaminiVatoTwo";
import Kirtan from "./pages/Kirtan";
import BrahmRatna from "./pages/BrahmRatna";
import SearchWord from "./pages/SearchWord";
import Paramrut from "./pages/Paramrut";
import AksharVaniSearch from "./pages/AksharVaniSearch";
import GururunAdaKariye from "./pages/GururunAdaKariye";
import HariroonAdaKariye from "./pages/HariroonAdaKariye";
import SarasEkSahajanand from "./pages/SarasEkSahajanand";
import WhatsNew from "./pages/WhatsNew";
import Centers from "./pages/Centers";
import IndiaCenters from "./pages/IndiaCenters";
import InternationalCenters from "./pages/InternationalCenters";
import DailyDetailEditor from "./pages/DailyDetailEditor";
import Parampara from "./pages/Parampara";
import "./App.css";
import "./styles/DarkTheme.css";
import { ThemeProvider } from "./ThemeContext";

function App() {
  return (
    <ThemeProvider>
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/whats-new" element={<WhatsNew />} />
          <Route path="/centers" element={<Centers />} />
          <Route path="/centers/india" element={<IndiaCenters />} />
          <Route
            path="/centers/international"
            element={<InternationalCenters />}
          />
          <Route path="/admin/dailydetail" element={<DailyDetailEditor />} />
          <Route path="/about" element={<About />} />
          <Route path="/parampara" element={<Parampara />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pravachan/hari-paramrut" element={<HariParamrut />} />
          <Route
            path="/pravachan/hari-paramrut-two"
            element={<HariParamrutTwo />}
          />
          <Route
            path="/pravachan/hari-paramrut-three"
            element={<HariParamrutThree />}
          />
          <Route
            path="/pravachan/hari-paramrut-four"
            element={<HariParamrutFour />}
          />
          <Route path="/pravachan/hari-prasangam" element={<HariPrasangam />} />
          <Route path="/pravachan/akshar-vani" element={<AksharVani />} />
          <Route
            path="/pravachan/akshar-vani-two"
            element={<AksharVaniTwo />}
          />
          <Route path="/pravachan/mara-swamiji" element={<MaraSwamiji />} />
          <Route path="/pravachan/sant-vani" element={<SantVani />} />
          <Route path="/pravachan/sant-vani-two" element={<SantVaniTwo />} />
          <Route
            path="/pravachan/sevak-pravachan"
            element={<SevakPravachan />}
          />
          <Route
            path="/pravachan/haribhakt-pravachan"
            element={<HaribhaktPravachan />}
          />
          <Route path="/pravachan/shorts" element={<Shorts />} />
          <Route path="/pravachan/shorts-two" element={<ShortsTwo />} />
          <Route path="/pravachan/guest" element={<Guest />} />
          <Route
            path="/pravachan/transformation"
            element={<Transformation />}
          />
          <Route path="/pravachan/mara-guruhari" element={<MaraGuruhari />} />
          <Route
            path="/pravachan/baheno-pravachan"
            element={<BahenoPravachan />}
          />
          <Route
            path="/pravachan/saras-ek-sahajanand"
            element={<SarasEkSahajanand />}
          />
          <Route path="/pravachan/usa-yatra" element={<USAYatra />} />
          <Route
            path="/pravachan/gururun-ada-kariye"
            element={<GururunAdaKariye />}
          />
          <Route
            path="/pravachan/hariroon-ada-kariye"
            element={<HariroonAdaKariye />}
          />
          <Route path="/pravachan/canada-yatra" element={<CanadaYatra />} />
          <Route path="/pravachan/europe-yatra" element={<EuropeYatra />} />
          <Route path="/pravachan/vakta" element={<Vakta />} />
          <Route path="/pravachan/paramrut" element={<Paramrut />} />
          <Route
            path="/pravachan/akshar-vani-search"
            element={<AksharVaniSearch />}
          />
          <Route path="/pravachan/*" element={<Home />} />
          <Route path="/darshan/sahaj" element={<SahajDarshan />} />
          <Route path="/darshan/highlight" element={<HighLight />} />
          <Route path="/darshan/social-activity" element={<SocialActivity />} />
          <Route path="/darshan/pooja" element={<PoojaDarshan />} />
          <Route
            path="/darshan/samvad-and-nrutya"
            element={<SamvadAndNrutya />}
          />
          <Route path="/darshan/desh-bhakti" element={<DeshBhakti />} />
          <Route path="/darshan/pragatya" element={<PragatyaParv />} />
          <Route path="/darshan/seva-bhakti" element={<SevaBhakti />} />
          <Route
            path="/darshan/hari-prasang-darshan"
            element={<HariPrasangDarshan />}
          />
          <Route path="/darshan/jivan-darshan" element={<JivanDarshan />} />
          <Route path="/darshan/*" element={<Home />} />
          <Route path="/download/wallpaper" element={<Wallpaper />} />
          <Route
            path="/download/desktop-wallpaper"
            element={<DesktopWallpaper />}
          />
          <Route path="/download/smruti" element={<Smruti />} />
          <Route path="/download/smruti/:year" element={<Smruti />} />
          <Route path="/download/smruti/:year/:folder" element={<Smruti />} />
          <Route path="/smrutimap" element={<SmrutiMap />} />
          <Route path="/download/*" element={<Home />} />
          <Route path="/spotify" element={<Spotify />} />
          <Route path="/niramay-studios" element={<NiramayStudios />} />
          <Route path="/twitter" element={<Twitter />} />
          <Route path="/granth/shikshapatri" element={<Shikshapatri />} />
          <Route
            path="/granth/shikshapatri-mukhpath"
            element={<ShikshapatriMukhpath />}
          />
          <Route path="/calendar2026" element={<Calendar2026 />} />
          <Route path="/pradesh-map" element={<PradeshMap />} />
          <Route path="/asoj-map" element={<AsojMap />} />
          <Route path="/hariprabodham-dham" element={<HariPrabodhamDham />} />
          <Route path="/vicharan-darshan" element={<VicharanDarshan />} />
          <Route path="/vicharan-map" element={<VicharanMap />} />
          <Route path="/granth/anirdeshi-amrut" element={<AnirdeshiAmrut />} />
          <Route path="/granth/prite" element={<Prite />} />
          <Route path="/granth/sahradayi" element={<Sahradayi />} />
          <Route path="/sahradayi" element={<Sahradayi />} />
          <Route path="/granth/amrutbindu" element={<Amrutbindu />} />
          <Route path="/amrutbindu" element={<Amrutbindu />} />
          <Route path="/granth/chaitanyadhodh" element={<ChaitanyaDhodh />} />
          <Route path="/chaitanyadhodh" element={<ChaitanyaDhodh />} />
          <Route
            path="/granth/ambrish-upnishad"
            element={<AmbrishUpnishad />}
          />
          <Route
            path="/granth/bhede-sakshi-anant"
            element={<BhedeSakshiAnant />}
          />
          <Route path="/granth/vachanamrut" element={<Vachanamrut />} />
          <Route path="/granth/swamini-vato" element={<SwaminiVato />} />
          <Route path="/granth/swamini-vato-2" element={<SwaminiVatoTwo />} />
          <Route path="/granth/kirtan" element={<Kirtan />} />
          <Route path="/granth/brahm-ratna" element={<BrahmRatna />} />
          <Route path="/granth/search-word" element={<SearchWord />} />
          <Route path="/prabodham-prasangam" element={<PrabodhamPrasangam />} />
          <Route
            path="/hariprabodham-spotify"
            element={<HariprabodhamSpotify />}
          />
          <Route path="/iakshar-spotify" element={<IAksharSpotify />} />
          <Route
            path="/toronto-rhythm-spotify"
            element={<TorontoRhythmSpotify />}
          />
          <Route
            path="/ambrish-upnishad-spotify"
            element={<AmbrishUpnishadSpotify />}
          />
        </Routes>
        <Footer />
      </div>
    </Router>
    </ThemeProvider>
  );
}

export default App;
